module.exports = __webpack_public_path__ + "static/media/imagem2.e25596b3.jpeg";